import { render, staticRenderFns } from "./UsersCrew.vue?vue&type=template&id=2882a260"
import script from "./UsersCrew.vue?vue&type=script&lang=js"
export * from "./UsersCrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports